import { useAuth } from "@entities/auth";
import { ToastService } from "@shared/lib/services";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SignInFormValues } from "../types/DataTypes";

export function useSignInValidation() {
  const [loading, setLoading] = useState<boolean>(false);
  const [isResetting, setResetting] = useState<boolean>(false);

  const navigate = useNavigate();

  const { login, resetPassword } = useAuth();

  const handleLogin = async (formValues: SignInFormValues) => {
    const { email, password } = formValues;
    setLoading(true);
    try {
      await login(email, password);
      // navigate("/");
    } catch (err) {
      const errorMessage = (err as Error).message;

      if (errorMessage.includes("invalid-credential")) {
        ToastService.error("Either Email id or Username is incorrect");
        throw new Error("Either Email id or Username is incorrect");
      }
      ToastService.error("Something went wrong. Please try again");
      throw new Error("Something went wrong. Please try again");
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordReset = async (email: string) => {
    setResetting(true);
    try {
      await resetPassword(email);
      ToastService.success("Password reset email sent. Check your inbox.");
    } catch (err) {
      const errorMessage = (err as { code?: string }).code;

      if (errorMessage === "auth/user-not-found") {
        return ToastService.error("No account found with this email.");
      }
      if (errorMessage === "auth/invalid-email") {
        return ToastService.error(
          "Invalid email format. Please check and try again."
        );
      }
      return ToastService.error("Something went wrong. Please try again.");
    } finally {
      setResetting(false);
    }
  };

  return { loading, handleLogin, handlePasswordReset, isResetting };
}
